import React from 'react';
import {
  AppState,
  Auth0Provider,
} from '@auth0/auth0-react';
import { useConfig } from '../../hooks/useConfig';
const Auth0ProviderWithHistory: React.FC<React.PropsWithChildren> = (props) => {
  const config = useConfig();
  const onRedirectCallback = (appState?: AppState) => {
    window.history.replaceState(
      {},
      document.title,
      appState?.returnTo || window.location.pathname,
    );
    window.location.href = appState?.returnTo || window.location.pathname;
  };

  return (
    <Auth0Provider
      domain={config.AUTH0.DOMAIN}
      clientId={config.AUTH0.CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: config.AUTH0.AUDIENCE,
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {props.children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
